import React from "react";
import { whySelectra } from "../data/siteData";
import useScrollAnimation from "../hooks/useScrollAnimation";
import "./WhySelectra.css";

export default function WhySelectra() {
  const sectionRef = useScrollAnimation(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".why__item"), {
      y: 50,
      opacity: 0,
      duration: 0.8,
      stagger: 0.1,
      ease: "power3.out",
      scrollTrigger: { trigger: el, start: "top 75%" },
    });
  }, []);

  return (
    <section className="why section" ref={sectionRef}>
      <div className="container">
        <span className="eyebrow">Why Selectra</span>
        <h2 className="why__title">WHAT SETS US APART</h2>

        <div className="why__grid">
          {whySelectra.map((item) => (
            <div className="why__item" key={item.number}>
              <span className="why__item-number glow-text">{item.number}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
